import { render, staticRenderFns } from "./XmGoodsTable.vue?vue&type=template&id=03c7c662&scoped=true"
import script from "./XmGoodsTable.vue?vue&type=script&lang=js"
export * from "./XmGoodsTable.vue?vue&type=script&lang=js"
import style0 from "./XmGoodsTable.vue?vue&type=style&index=0&id=03c7c662&prod&lang=scss&scoped=true"
import style1 from "./XmGoodsTable.vue?vue&type=style&index=1&id=03c7c662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03c7c662",
  null
  
)

export default component.exports